import type { FC } from 'react';
import Content from '../Content';
import ButtonHideSession from '../../Shared/ButtonHideSession';
import ButtonGoToSession from '../../Shared/ButtonGoToSession';
import { ImageProperties } from '../../../../../../core/domain/map';

type Props = {
    properties: ImageProperties | null;
};

const ImagePopupOnClick: FC<Props> = ({ properties }) => {
    if (!properties) {
        return null;
    }

    return (
        <>
            <Content properties={properties} />
            <ButtonGoToSession sessionId={properties.sessionId} imageId={properties.id} />
            <ButtonHideSession sessionId={properties.sessionId} />
        </>
    );
};

export default ImagePopupOnClick;
